import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\MemberExportCountController::__invoke
* @see app/Http/Controllers/Creator/MemberExportCountController.php:15
* @route '/app/creator/members/export/count'
*/
export const count = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: count.url(options),
    method: 'get',
})

count.definition = {
    methods: ["get","head"],
    url: '/app/creator/members/export/count',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\MemberExportCountController::__invoke
* @see app/Http/Controllers/Creator/MemberExportCountController.php:15
* @route '/app/creator/members/export/count'
*/
count.url = (options?: RouteQueryOptions) => {
    return count.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\MemberExportCountController::__invoke
* @see app/Http/Controllers/Creator/MemberExportCountController.php:15
* @route '/app/creator/members/export/count'
*/
count.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: count.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberExportCountController::__invoke
* @see app/Http/Controllers/Creator/MemberExportCountController.php:15
* @route '/app/creator/members/export/count'
*/
count.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: count.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\MemberExportCountController::__invoke
* @see app/Http/Controllers/Creator/MemberExportCountController.php:15
* @route '/app/creator/members/export/count'
*/
const countForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: count.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberExportCountController::__invoke
* @see app/Http/Controllers/Creator/MemberExportCountController.php:15
* @route '/app/creator/members/export/count'
*/
countForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: count.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberExportCountController::__invoke
* @see app/Http/Controllers/Creator/MemberExportCountController.php:15
* @route '/app/creator/members/export/count'
*/
countForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: count.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

count.form = countForm

const exportMethod = {
    count: Object.assign(count, count),
}

export default exportMethod